import React, { useState } from 'react';
import Select from 'react-select';
import { useSidebar } from '../../SidebarContext';
// import { useSidebar } from '../SidebarContext';
// import { countries } from "./Country";
// import { indianStates } from './IndianStates';
import { useNavigate } from 'react-router-dom';
import { countries } from '../Country';
import { indianStates } from '../IndianStates';
import CustomerContactTable from './AdmissionContactTable';
import { getDecryptedUserFromCookie } from '../utils/getCookie';
import normalizePhoneNumber from '../utils/normalizePhoneNumber';
// import CustomerContactTable from './CustomerContactTable';

const AddAdmission2 = () => {
    const { isSidebarOpen } = useSidebar();
    const [selectedType, setSelectedType] = useState('individual');
    const [activeTab, setActiveTab] = useState(1);
    const [isMoreDetailsOpen, setMoreDetailsOpen] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const handleTabClick = (tabIndex) => setActiveTab(tabIndex);
    const toggleMoreDetails = () => setMoreDetailsOpen(!isMoreDetailsOpen);

    const navigate = useNavigate();
    const [contactList, setContactList] = useState([]);
    const url = process.env.REACT_APP_LINK

    const [formData, setFormData] = useState({
        customerName: "",
        companyName: "",
        displayName: "",
        email: "",
        phone1: "",
        phone2: "",
        gstNumber: "",
        placeOfSupply: "",
        pan: "",
        currency: "INR",
        remarks: "",
        website_url: "",
        department: "",
        designation: "",
        twitter: "",
        skype: "",
        facebook: "",
        billingAddress: {
            attention: "",
            country: "",
            address: "",
            city: "",
            state: "",
            pincode: "",
            number: "",
        },
        shippingAddress: {
            attention: "",
            country: "",
            address: "",
            city: "",
            state: "",
            pincode: "",
            number: "",
        },
        user_id: isLoggedIn.main_id,
        user_name: isLoggedIn.full_name,
        sales_person: ""


    });

    const [document, setDocument] = useState(null);
    const [previewUrl, setPreviewUrl] = useState(null);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        setDocument(file);
        if (file) {
            setPreviewUrl(URL.createObjectURL(file)); // generate preview
        } else {
            setPreviewUrl(null);
        }
    };


    const handleInputChange = (e) => {
        const { name, value } = e.target;

        if (name === "phone1" || name === "phone2") {
            const normalized = normalizePhoneNumber(value);
            setFormData(prev => ({ ...prev, [name]: normalized }));
        } else {
            setFormData(prev => ({ ...prev, [name]: value }));
        }

    };

    const handleSelectChange = (selected, { name }) => {
        setFormData(prev => ({ ...prev, [name]: selected ? selected.value : "" }));
    };



    const handleBillingChange = (e) => {
        const { name, value } = e.target;

        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleShippingChange = (e) => {
        const { name, value } = e.target;
        const processedValue = name === "number" ? normalizePhoneNumber(value) : value;

        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: processedValue,
            }
        }));
    };

    const handleBillingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            billingAddress: {
                ...prev.billingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };

    const handleShippingSelectChange = (selected, { name }) => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: {
                ...prev.shippingAddress,
                [name]: selected ? selected.value : "",
            }
        }));
    };


    const copyBillingToShipping = () => {
        setFormData(prev => ({
            ...prev,
            shippingAddress: { ...prev.billingAddress }
        }));
    };


    const currencyOptions = [
        { value: 'INR', label: 'INR' },
    ];

    const handleSubmit = async (e) => {
        e.preventDefault();
        const finalData = {

            ...formData,
            customerType: selectedType,
            contact: contactList,
        };

        const formDataToSend = new FormData();
        formDataToSend.append('document', document); // attach file
        for (const key in finalData) {
            if (typeof finalData[key] === 'object') {
                formDataToSend.append(key, JSON.stringify(finalData[key]));
            } else {
                formDataToSend.append(key, finalData[key]);
            }
        }

        try {
            const response = await fetch(`${url}/api/customer`, {
                method: 'POST',
                body: formDataToSend
            });

            const data = await response.json();
            if (response.ok) {
                navigate('/admission', { state: { ...finalData, id: data.id } });
                alert('Customer created successfully!');
            } else {
                throw new Error(data.error || 'Error occurred');
            }
        } catch (error) {
            alert(error.message);
        }
    };

    // console.log("Form Data:", JSON.stringify(formData, null, 2));

    return (
        <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
            <form className="oms-modal-form" onSubmit={handleSubmit}>
                <div className="oms-form-group">
                    <label className="oms-form-label">Customer Type</label>
                    <div className="oms-form-radio">
                        <label
                            className={`radio-label ${selectedType === 'individual' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="individual"
                                checked={selectedType === 'individual'}
                                onChange={() => setSelectedType('individual')}
                            />
                            Individual
                        </label>
                        <label
                            className={`radio-label ${selectedType === 'company' ? 'checked' : ''}`}
                        >
                            <input
                                type="radio"
                                name="customerType"
                                value="company"
                                checked={selectedType === 'company'}
                                onChange={() => setSelectedType('company')}
                            />
                            Company
                        </label>
                    </div>
                </div>
                <div className="oms-form-flex">
                    <div className="oms-form-group">
                        <label htmlFor="customerName" className="oms-form-label">
                            Customer Name
                        </label>
                        <input
                            type="text"
                            id="customerName"
                            name="customerName"
                            value={formData.customerName}
                            onChange={handleInputChange}
                            placeholder="Enter customer name"
                            required
                        />
                    </div>


                    <div className="oms-form-group">
                        <label htmlFor="companyName" className="oms-form-label">
                            Company Name
                        </label>
                        <input type="text" id="companyName"
                            name="companyName"
                            value={formData.companyName}
                            onChange={handleInputChange}
                            placeholder="Enter company name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="displayName" className="oms-form-label">
                            Display Name
                        </label>
                        <input type="text"
                            name="displayName"
                            value={formData.displayName}

                            onChange={handleInputChange}
                            placeholder="Enter display name" />
                    </div>

                    <div className="oms-form-group">
                        <label htmlFor="currency" className="oms-form-label">
                            Currency
                        </label>
                        <Select
                            name="currency"
                            value={formData.currency ? { value: formData.currency, label: formData.currency } : null}
                            options={currencyOptions}
                            onChange={handleSelectChange}
                            isDisabled
                        />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="email" className="oms-form-label">
                            Email
                        </label>
                        <input type="email" id="email"
                            name="email"
                            value={formData.email}
                            onChange={handleInputChange}
                            placeholder="Enter email" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="phone1" className="oms-form-label">
                            Phone Number 1
                        </label>
                        <input type="tel" id="phone1"
                            name="phone1"
                            value={formData.phone1}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault(); // Prevent non-numeric characters
                                }
                            }}
                            placeholder="Enter phone number 1" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="phone2" className="oms-form-label">
                            Phone Number 2
                        </label>
                        <input type="tel" id="phone2"
                            name="phone2"
                            value={formData.phone2}
                            onChange={handleInputChange}
                            onKeyPress={(e) => {
                                if (!/[0-9]/.test(e.key)) {
                                    e.preventDefault(); // Prevent non-numeric characters
                                }
                            }}
                            placeholder="Enter phone number 2" />
                    </div>
                    <div className="oms-form-group">
                        <label htmlFor="sales_person" className="oms-form-label">
                            Sales Person Name / ID
                        </label>
                        <input type="text" id="sales_person"
                            name="sales_person"
                            value={formData.sales_person}
                            onChange={handleInputChange}
                            placeholder="Enter Sales Person Name or Id" />
                    </div>

                </div>


                {/* Tabs */}
                <div className="customer-form-tab">
                    <ul className="tab-list">
                        <li
                            className={`tab ${activeTab === 1 ? 'active' : ''}`}
                            onClick={() => handleTabClick(1)}
                        >
                            Other Details
                        </li>
                        <li
                            className={`tab ${activeTab === 2 ? 'active' : ''}`}
                            onClick={() => handleTabClick(2)}
                        >
                            Address
                        </li>
                        <li
                            className={`tab ${activeTab === 3 ? 'active' : ''}`}
                            onClick={() => handleTabClick(3)}
                        >
                            Contact
                        </li>
                        <li
                            className={`tab ${activeTab === 4 ? 'active' : ''}`}
                            onClick={() => handleTabClick(4)}
                        >
                            Remarks
                        </li>
                    </ul>

                    {/* Tab Content */}
                    <div className="tab-content">
                        {activeTab === 1 && (
                            <div className="tab-block">
                                <div className="oms-form-flex">
                                    <div className="oms-form-group">
                                        <label htmlFor="number" className="oms-form-label">
                                            GST Number
                                        </label>
                                        <input
                                            type="text"
                                            id="gstNumber"
                                            name="gstNumber"
                                            value={formData.gstNumber}
                                            onChange={handleInputChange}
                                            placeholder="Enter your GST number"
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="name" className="oms-form-label">
                                            Place of supply
                                        </label>
                                        <Select
                                            name="placeOfSupply"
                                            value={formData.placeOfSupply ? { value: formData.placeOfSupply, label: formData.placeOfSupply } : null}
                                            options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                            onChange={handleSelectChange}
                                            placeholder="Select state"
                                            isClearable
                                        />
                                    </div>
                                    <div className="oms-form-group">
                                        <label htmlFor="pan" className="oms-form-label">Pan</label>
                                        <input
                                            type="text"
                                            id="pan"
                                            name="pan"
                                            value={formData.pan}
                                            onChange={handleInputChange}
                                            placeholder="Enter your PAN number"
                                        />
                                    </div>
                                </div>
                                <div className="oms-form-group">
                                    <label htmlFor="file" className="oms-form-label">Document</label>
                                    <label htmlFor="file" className="oms-form-upload">
                                        <i className="fa-solid fa-arrow-up-from-bracket"></i> Upload File
                                        <input type="file" id="file" name="document" className="file-input" accept="image/*" onChange={handleFileChange} />
                                    </label>

                                    {/* 🖼️ Show preview */}

                                </div>
                                {previewUrl && (
                                    <img
                                        src={previewUrl}
                                        alt="Selected Preview"
                                        style={{ marginTop: '10px', width: '150px', height: 'auto', borderRadius: '4px', border: '1px solid #ccc' }}
                                    />
                                )}


                                <p className="oms-add-more-details-link" onClick={toggleMoreDetails}>
                                    Add more details
                                </p>
                                {isMoreDetailsOpen && (
                                    <div className="oms-add-more-details-section">
                                        <div className="oms-form-flex">
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label" >
                                                    Website URL
                                                </label>
                                                <input type="text" placeholder="Enter your Website URL" name='website_url' value={formData.website_url} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label" >
                                                    Department
                                                </label>
                                                <input type="text" placeholder="Enter your department" name='department' value={formData.department} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Designation
                                                </label>
                                                <input type="text" placeholder="Enter your designation" name='designation' value={formData.designation} onChange={handleInputChange} />
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Twitter
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your twitter URL" name='twitter' value={formData.twitter} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Skype
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your skype URL" name='skype' value={formData.skype} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                            <div className="oms-form-group">
                                                <label htmlFor="text" className="oms-form-label">
                                                    Facebook
                                                </label>
                                                <div className="oms-form-with-icon">
                                                    <input type="text" placeholder="Enter your facebook URL" name='facebook' value={formData.facebook} onChange={handleInputChange} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        )}
                        {activeTab === 2 && (
                            <div className="tab-block">
                                <div className="oms-address-section">
                                    {/* Billing Address */}
                                    <div className="oms-billing-address">
                                        <div className="oms-address-heading">Billing address</div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Attention</label>
                                            <input
                                                type="text"
                                                name="attention"
                                                value={formData.billingAddress.attention}
                                                onChange={handleBillingChange}
                                                placeholder="Enter Your Attention"
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Country/Region</label>
                                            <Select
                                                name="country"
                                                value={formData.billingAddress.country ? { value: formData.billingAddress.country, label: formData.billingAddress.country } : null}
                                                options={countries.map((country) => ({ value: country.name, label: country.name }))}
                                                onChange={handleBillingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Address</label>
                                            <textarea
                                                name="address"
                                                placeholder="Street 1"
                                                value={formData.billingAddress.address}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Enter Your City"
                                                value={formData.billingAddress.city}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">State</label>
                                            <Select
                                                name="state"
                                                value={formData.billingAddress.state ? { value: formData.billingAddress.state, label: formData.billingAddress.state } : null}
                                                options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                                onChange={handleBillingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Pincode</label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                placeholder="Enter Your Pincode"
                                                value={formData.billingAddress.pincode}
                                                onChange={handleBillingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Phone Number</label>
                                            <input
                                                type="tel"
                                                name="number"
                                                placeholder="Enter Your Number"
                                                value={formData.billingAddress.number}
                                                onChange={handleBillingChange}
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // Prevent non-numeric characters
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Shipping Address */}
                                    <div className="oms-shipping-address">
                                        <div className="oms-address-heading">
                                            Shipping Address{" "}
                                            <span onClick={copyBillingToShipping}>
                                                ( <i className="fa-regular fa-clipboard"></i> same as billing )
                                            </span>
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Attention</label>
                                            <input
                                                type="text"
                                                name="attention"
                                                placeholder="Enter Your Attention"
                                                value={formData.shippingAddress.attention}
                                                onChange={handleShippingChange}
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Country/Region</label>
                                            <Select
                                                name="country"
                                                value={formData.shippingAddress.country ? { value: formData.shippingAddress.country, label: formData.shippingAddress.country } : null}
                                                options={countries.map((country) => ({ value: country.name, label: country.name }))}
                                                onChange={handleShippingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Address</label>
                                            <textarea
                                                name="address"
                                                placeholder="Street 1"
                                                value={formData.shippingAddress.address}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">City</label>
                                            <input
                                                type="text"
                                                name="city"
                                                placeholder="Enter Your City"
                                                value={formData.shippingAddress.city}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">State</label>
                                            <Select
                                                name="state"
                                                value={formData.shippingAddress.state ? { value: formData.shippingAddress.state, label: formData.shippingAddress.state } : null}
                                                options={indianStates.map((state) => ({ value: state.name, label: state.name }))}
                                                onChange={handleShippingSelectChange}
                                                placeholder="Select an option"
                                                isClearable
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Pincode</label>
                                            <input
                                                type="number"
                                                name="pincode"
                                                placeholder="Enter Your Pincode"
                                                value={formData.shippingAddress.pincode}
                                                onChange={handleShippingChange}
                                                required
                                            />
                                        </div>

                                        <div className="oms-form-group">
                                            <label className="oms-form-label">Phone Number</label>
                                            <input
                                                type="tel"
                                                name="number"
                                                placeholder="Enter Your Number"
                                                value={formData.shippingAddress.number}
                                                onChange={handleShippingChange}
                                                onKeyPress={(e) => {
                                                    if (!/[0-9]/.test(e.key)) {
                                                        e.preventDefault(); // Prevent non-numeric characters
                                                    }
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {activeTab === 3 && (
                            <div className="tab-block">
                                <CustomerContactTable
                                    contacts={contactList}
                                    setContacts={setContactList}
                                />
                            </div>
                        )}

                        {activeTab === 4 && (
                            <div className="tab-block">
                                <div className="oms-form-group">
                                    <label for="remarks" className="oms-form-label">Remark:</label>
                                    <textarea id="remarks" name="remarks"
                                        value={formData.remarks}
                                        onChange={handleInputChange}
                                        rows="4" placeholder="Additional comments or preferences"></textarea>
                                </div>
                            </div>
                        )}
                    </div>
                </div>



                <div className="oms-form-actions">

                    <button type="submit">Submit</button>
                </div>
            </form>
        </div >
    );
};

export default AddAdmission2;
